// extracted by mini-css-extract-plugin
export var productImage = "_ne-0";